import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { characters } from "../data/characters";
import { Slider } from "../components/Slider";
import { CharacterCard } from "../components/CharacterCard";
import { CharacterSelection } from "../components/CharacterSelection";
import scss from "./SelectSquad.module.scss";
import WithMotion from "../utils/withMotion";

export const SelectSquad = () => {
  const { user, theater, selectedCharacters, squadSubmission } = useSelector(
    (state: any) => state
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (squadSubmission) {
    return <Redirect to="/your-squad" />;
  }

  if (!user) {
    return <Redirect to="/sign-up" />;
  }
  if (!theater) {
    return <Redirect to="/sign-up-theater" />;
  }

  return (
    <main className={scss.main}>
      <h2 className={scss.headline}>
        SELECT <span>5</span>
        DC <br /> SUPER-VILLAINS TO <br />
        JOIN YOUR SQUAD
      </h2>
      <Slider step={2} />
      <div className={scss.characters}>
        {Object.values(characters).map((c) => (
          <CharacterCard
            key={c.id}
            character={c}
            selectedCharacters={selectedCharacters}
          />
        ))}
      </div>
      <CharacterSelection />
    </main>
  );
};

export default WithMotion(SelectSquad);
